import type { FC, ReactNode } from 'react'

import { Check, X } from 'lucide-react'
import SectionHeading from '@/components/landing/section-heading'
import { BEFORE_ELENIX, WITH_ELENIX } from '@/constants/landing'

const WhySection: FC = (): ReactNode => {
    return (
        <section id='why-elenix' aria-labelledby='why-title' className='bg-white py-20 sm:py-28'>
            <div className='mx-auto max-w-6xl px-5 sm:px-6 lg:px-8'>
                <SectionHeading
                    id='why-title'
                    align='center'
                    eyebrow="Why Elenix"
                    title="Stop chasing updates. Start the day informed."
                    description="Most owners piece the day together from phone calls, notebooks and spreadsheets. Elenix keeps it in one place, updated as your team works."
                />

                <div className='mt-14 grid gap-5 lg:grid-cols-2'>
                    <div className='reveal rounded-3xl border border-border bg-background p-7 sm:p-9'>
                        <h3 className='text-sm font-bold uppercase tracking-[0.14em] text-muted-foreground'>
                            Without Elenix
                        </h3>

                        <ul className='mt-7 space-y-5'>
                            {BEFORE_ELENIX.map(item => (
                                <li key={item} className='flex gap-3.5'>
                                    <span className='mt-0.5 grid size-6 shrink-0 place-items-center rounded-full bg-white text-muted-foreground ring-1 ring-border'>
                                        <X className='size-3.5' />
                                    </span>

                                    <span className='text-base leading-relaxed text-muted-foreground'>
                                        {item}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className='reveal relative isolate overflow-hidden rounded-3xl bg-primary p-7 text-primary-foreground shadow-[0_30px_60px_-30px_rgb(53_102_219/0.8)] sm:p-9'>
                        <div aria-hidden='true' className='absolute -right-20 -top-24 -z-10 size-72 rounded-full bg-white/10' />
                        <div aria-hidden='true' className='absolute -bottom-28 right-16 -z-10 size-56 rounded-full bg-white/5' />

                        <h3 className='text-sm font-bold uppercase tracking-[0.14em] text-brand-50'>
                            With Elenix
                        </h3>

                        <ul className='mt-7 space-y-5'>
                            {WITH_ELENIX.map(item => (
                                <li key={item} className='flex gap-3.5'>
                                    <span className='mt-0.5 grid size-6 shrink-0 place-items-center rounded-full bg-white text-primary'>
                                        <Check className='size-3.5' strokeWidth={3} />
                                    </span>

                                    <span className='text-base font-medium leading-relaxed text-white'>
                                        {item}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default WhySection
